<div class="breadcrumbs--page-nav hidden-xs hidden-sm">
  <div class="container">
    <p>
      <a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a
    [routerLink]="'/products'">{{"statictext.products" | cxTranslate}}</a><span> &gt;
    </span><strong class="breadcrumb_Bold_Txt">{{"statictext.realworldevidence" | cxTranslate}}</strong>
  </p>
</div>
</div>
<!--For Desktop-->
@if (firstheadline | async; as data) {
  <div class="product_image-textSide-Image desk_collapsable desktop_Rwe_Tabs"
    [ngStyle]="{'background-image':'url('+getImage(data.media)+')'}">
    <div class="product_Realworld_Whitebox">
      <h2 class="top_Headline" [innerHTML]="data.h2content"></h2>
      <div class="row tabs_Heading_Row">
        <div class="label_Container1 col-md-6">
          <!--For the line-->
          <div class="top_Text_Container">
            <div class="bar left"></div>
            <div class="line left-line"></div>
            <p [innerHTML]="data.urlLink" class="top_Heading_Text"></p>
            <div class="line right-line"></div>
            <div class="bar right"></div>
          </div>
          <!--top headings-->
          <div class="tab_Header_container">
            <div class="tab_Heading" [innerHTML]="cardsList[0]?.h2content" (click)="setActive(0)"
            [class.active]="activeIndex === 0"></div>
            <div class="tab_Heading" [innerHTML]="cardsList[1]?.h2content" (click)="setActive(1)"
            [class.active]="activeIndex === 1"></div>
          </div>
        </div>
        <div class="label_Container2 col-md-6">
          <!--For the line-->
          <div class="top_Text_Container">
            <div class="bar left"></div>
            <div class="line left-line"></div>
            <p [innerHTML]="data.paragraphcontent" class="top_Heading_Text"></p>
            <div class="line right-line"></div>
            <div class="bar right"></div>
          </div>
          <!--for the top headings-->
          <div class="tab_Header_container">
            <div class="tab_Heading" [innerHTML]="cardsList[2]?.h2content" (click)="setActive(2)"
              [class.active]="activeIndex === 2">
            </div>
            <div class="tab_Heading" [innerHTML]="cardsList[3]?.h2content" (click)="setActive(3)"
              [class.active]="activeIndex === 3">
            </div>
          </div>
        </div>
      </div>
      <!--middle container-->
      @for (item of cardsList; track item; let i = $index) {
        @if (activeIndex === i) {
          <div [ngClass]="['content_Container', 'container_' + i]">
            <p [innerHTML]="item.content" class="sub_Container_Text"></p>
            <div class="sub_Container">
              <div class="headline">{{item.urlLink}}</div>
              <!--cards for 1 and 3 tabs(blue colour tabs)-->
              @if (i === 0 || i === 2;) {
                <div class="card_material">
                  <!--left container-->
                  <div class="svgbox">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 206 280" fill="none">
                      <path
                        d="M104.51 251.406L206 208.127V235.986L102.785 280L0 236.166V208.309L101.057 251.406C102.103 251.85 103.464 251.85 104.51 251.406ZM0 0.184868V141.205L102.785 185.036L206 141.022V0L0 0.184868ZM101.057 203.925L0 160.83V188.686L102.785 232.516L206 188.502V160.645L104.51 203.925C103.464 204.369 102.103 204.369 101.057 203.925Z"
                        fill="url(#paint0_linear_10100_101720)" />
                        <text x="50%" y="100px" fill="#194965" class="percentage" [innerHTML]="item.itemPerPack"></text>
                        <defs>
                          <linearGradient id="paint0_linear_10100_101720" x1="103" y1="177.382" x2="103" y2="280"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#D8E5EF" />
                            <stop offset="1" stop-color="#D8E5EF" stop-opacity="0" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <!--left container-->
                    <div class="sol_Type" [innerHTML]="item.solutiontype"></div>
                  </div>
                }
                <!--sub headings for 1 and 3 tab-->
                @if (i === 0 || i === 2;) {
                  <div class="sub_Text_Container">
                    @if (item.paragraphcontent) {
                      <div class="para_content" [innerHTML]="item?.paragraphcontent"></div>
                    }
                    @if (item.h3content) {
                      <div class="h3content" [innerHTML]="item?.h3content"></div>
                    }
                  </div>
                }
                <!--cards for 2 and 4 tabs(green tabs)-->
                @if (i === 1 || i === 3;) {
                  <div class="cards">
                    <!--card-1-->
                    <div class="card-material">
                      <div class="svg_Section">
                        <div class="svg-box-even">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123 246" fill="none">
                            <path
                              d="M62.4018 220.878L123 182.854V207.33L61.3718 246L0 207.489V183.015L60.3397 220.878C60.9643 221.269 61.7772 221.269 62.4018 220.878ZM0 0.16242V124.058L61.3718 162.568L123 123.898V0L0 0.16242ZM60.3397 179.162L0 141.301V165.774L61.3718 204.282L123 165.612V141.138L62.4018 179.162C61.7772 179.552 60.9643 179.552 60.3397 179.162Z"
                              fill="url(#paint0_linear_10100_101479)" />
                              <text x="50%" y="80px" fill="#194965" class="percentage">{{item.itemPerPack}}</text>
                              <defs>
                                <linearGradient id="paint0_linear_10100_101479" x1="61.5" y1="155.843" x2="61.5"
                                  y2="246" gradientUnits="userSpaceOnUse">
                                  <stop stop-color="#78BE20" stop-opacity="0.2" />
                                  <stop offset="1" stop-color="#78BE20" stop-opacity="0" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                          <div class="sol_Type" [innerHTML]="item.solutiontype"></div>
                        </div>
                        <div class="card-text" [innerHTML]="item.paragraphcontent"></div>
                      </div>
                      <!--card-2-->
                      <div class="card-material">
                        <div class="svg_Section">
                          <div class="svg-box-even">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123 246" fill="none">
                              <path
                                d="M62.4018 220.878L123 182.854V207.33L61.3718 246L0 207.489V183.015L60.3397 220.878C60.9643 221.269 61.7772 221.269 62.4018 220.878ZM0 0.16242V124.058L61.3718 162.568L123 123.898V0L0 0.16242ZM60.3397 179.162L0 141.301V165.774L61.3718 204.282L123 165.612V141.138L62.4018 179.162C61.7772 179.552 60.9643 179.552 60.3397 179.162Z"
                                fill="url(#paint0_linear_10100_101479)" />
                                <text x="50%" y="80px" fill="#194965" class="percentage">{{item.text2}}</text>
                                <defs>
                                  <linearGradient id="paint0_linear_10100_101479" x1="61.5" y1="155.843" x2="61.5"
                                    y2="246" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#78BE20" stop-opacity="0.2" />
                                    <stop offset="1" stop-color="#78BE20" stop-opacity="0" />
                                  </linearGradient>
                                </defs>
                              </svg>
                            </div>
                            <div class="sol_Type" [innerHTML]="item.headline"></div>
                          </div>
                          <div class="card-text" [innerHTML]="item.name"></div>
                        </div>
                        <!--card-3-->
                        <div class="card-material">
                          <div class="svg_Section">
                            <div class="svg-box-even">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123 246" fill="none">
                                <path
                                  d="M62.4018 220.878L123 182.854V207.33L61.3718 246L0 207.489V183.015L60.3397 220.878C60.9643 221.269 61.7772 221.269 62.4018 220.878ZM0 0.16242V124.058L61.3718 162.568L123 123.898V0L0 0.16242ZM60.3397 179.162L0 141.301V165.774L61.3718 204.282L123 165.612V141.138L62.4018 179.162C61.7772 179.552 60.9643 179.552 60.3397 179.162Z"
                                  fill="url(#paint0_linear_10100_101479)" />
                                  <text x="50%" y="80px" fill="#194965" class="percentage">{{item.text3}}</text>
                                  <defs>
                                    <linearGradient id="paint0_linear_10100_101479" x1="61.5" y1="155.843" x2="61.5"
                                      y2="246" gradientUnits="userSpaceOnUse">
                                      <stop stop-color="#78BE20" stop-opacity="0.2" />
                                      <stop offset="1" stop-color="#78BE20" stop-opacity="0" />
                                    </linearGradient>
                                  </defs>
                                </svg>
                              </div>
                              <div class="sol_Type" [innerHTML]="item.text4"></div>
                            </div>
                            <div class="card-text" [innerHTML]="item.text1"></div>
                          </div>
                        </div>
                      }
                    </div>
                    <!--below text-->
                    <div class="large_Text" [innerHTML]="item.largeparagraphcontent"></div>
                  </div>
                }
              }
            </div>
          </div>
        }
        <!--mobile tabs-->
        @if (firstheadline | async; as data) {
          <div class="mobile_Rwe_Tabs">
            <h2 class="top_Headline" [innerHTML]="data.h2content"></h2>
            <div class="top_Text_Container">
              <div class="bar left"></div>
              <div class="line left-line"></div>
              <p [innerHTML]="data.urlLink" class="top_Heading_Text"></p>
              <div class="line right-line"></div>
              <div class="bar right"></div>
            </div>
            <div class="mobile_list">
              @for (item of cardsList; track item; let i = $index) {
                <!-- insert top text container after first two tabs -->
                @if (i === 2) {
                  <div class="top_Text_Container second_Top_Container">
                    <div class="bar left"></div>
                    <div class="line left-line"></div>
                    <p [innerHTML]="data.paragraphcontent" class="top_Heading_Text"></p>
                    <div class="line right-line"></div>
                    <div class="bar right"></div>
                  </div>
                }
                <div class="mobile_tab_heading tab_Heading" [class.active]="activeIndex === i" (click)="setActiveMobile(i)"
                [innerHTML]="item.h2content"></div>
                @if (activeIndex === i) {
                  <div class="mobile_content_panel" role="tabpanel">
                    <div [ngClass]="['content_Container', 'container_' + i]">
                      <p [innerHTML]="item.content" class="sub_Container_Text"></p>
                      <!-- Blue cards -->
                      @if (i === 0 || i === 2) {
                        <div class="sub_Container">
                          <div class="headline">{{item.urlLink}}</div>
                          <div class="card_material">
                            <div class="svg_Section_Mobile">
                              <div class="svgbox">
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 170" fill="none">
                                <path
                                  d="M63.922 144.672L126 106.331V131.009L62.8678 170L0 131.171V106.494L61.8098 144.672C62.449 145.061 63.2829 145.061 63.922 144.672ZM0 0.162766V65.1426L62.8678 103.971L126 64.9798V0L0 0.162766ZM61.8098 111.657L0 73.4798V98.1569L62.8678 136.977L126 97.9851V73.308L63.922 111.648C63.2829 112.037 62.449 112.037 61.8098 111.648V111.657Z"
                                  fill="url(#paint0_linear_10100_101783)" />
                                  <text x="50%" y="50px" fill="#194965" class="percentage">{{item.itemPerPack}}</text>
                                  <defs>
                                    <linearGradient id="paint0_linear_10100_101783" x1="63" y1="85" x2="63" y2="170"
                                      gradientUnits="userSpaceOnUse">
                                      <stop stop-color="#D8E5EF" />
                                      <stop offset="1" stop-color="#D8E5EF" stop-opacity="0" />
                                    </linearGradient>
                                  </defs>
                                </svg> -->
                                <div class="percentage percentage_Blue">{{item.itemPerPack}}</div>
                              </div>
                              <div class="sol_Type" [innerHTML]="item.solutiontype"></div>
                            </div>
                            <div class="vs_Vaccine">vs standard vaccines</div>
                          </div>
                          @if (item.paragraphcontent) {
                            <div class="para_content" [innerHTML]="item.paragraphcontent"></div>
                          }
                          @if (item.h3content) {
                            <div class="h3content" [innerHTML]="item.h3content"></div>
                          }
                        </div>
                      }
                      <!-- Green cards-->
                      @if (i === 1 || i === 3) {
                        <div class="cards">
                          <!-- card 1-->
                          <div class="card_1">
                            <div class="headline">{{item.urlLink}}</div>
                            <div class="card_material">
                              <div class="svg_Section_Mobile">
                                <div class="svg-box-even">
                                  <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 170"
                                  fill="none">
                                  <path
                                    d="M63.922 144.672L126 106.331V131.009L62.8678 170L0 131.171V106.494L61.8098 144.672C62.449 145.061 63.2829 145.061 63.922 144.672ZM0 0.162766V65.1426L62.8678 103.971L126 64.9798V0L0 0.162766ZM61.8098 111.657L0 73.4798V98.1569L62.8678 136.977L126 97.9851V73.308L63.922 111.648C63.2829 112.037 62.449 112.037 61.8098 111.648V111.657Z"
                                    fill="url(#paint0_linear_10100_101951)" />
                                    <text x="50%" y="50px" fill="#194965" class="percentage">{{item.itemPerPack}}</text>
                                    <defs>
                                      <linearGradient id="paint0_linear_10100_101951" x1="63" y1="85" x2="63" y2="170"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#78BE20" stop-opacity="0.2" />
                                        <stop offset="1" stop-color="#78BE20" stop-opacity="0" />
                                      </linearGradient>
                                    </defs>
                                  </svg> -->
                                  <div class="percentage percentage_Green">{{item.itemPerPack}}</div>
                                </div>
                                <div class="sol_Type" [innerHTML]="item.solutiontype"></div>
                              </div>
                              <div class="vs_Vaccine">vs standard vaccines</div>
                            </div>
                            @if (item.paragraphcontent) {
                              <div class="card-text" [innerHTML]="item.paragraphcontent"></div>
                            }
                          </div>
                          <!-- card 2 -->
                          <div class="card_2">
                            <div class="headline">{{item.urlLink}}</div>
                            <div class="card_material">
                              <div class="svg_Section_Mobile">
                                <div class="svg-box-even">
                                  <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 170"
                                  fill="none">
                                  <path
                                    d="M63.922 144.672L126 106.331V131.009L62.8678 170L0 131.171V106.494L61.8098 144.672C62.449 145.061 63.2829 145.061 63.922 144.672ZM0 0.162766V65.1426L62.8678 103.971L126 64.9798V0L0 0.162766ZM61.8098 111.657L0 73.4798V98.1569L62.8678 136.977L126 97.9851V73.308L63.922 111.648C63.2829 112.037 62.449 112.037 61.8098 111.648V111.657Z"
                                    fill="url(#paint0_linear_10100_101951)" />
                                    <text x="50%" y="50px" fill="#194965" class="percentage">{{item.text2}}</text>
                                    <defs>
                                      <linearGradient id="paint0_linear_10100_101951" x1="63" y1="85" x2="63" y2="170"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#78BE20" stop-opacity="0.2" />
                                        <stop offset="1" stop-color="#78BE20" stop-opacity="0" />
                                      </linearGradient>
                                    </defs>
                                  </svg> -->
                                  <div class="percentage percentage_Green">{{item.text2}}</div>
                                </div>
                                <div class="sol_Type" [innerHTML]="item.headline"></div>
                              </div>
                              <div class="vs_Vaccine">vs standard vaccines</div>
                            </div>
                            @if (item.name) {
                              <div class="card-text" [innerHTML]="item.name"></div>
                            }
                          </div>
                          <!-- card 3-->
                          <div class="card_3">
                            <div class="headline">{{item.urlLink}}</div>
                            <div class="card_material">
                              <div class="svg_Section_Mobile">
                                <div class="svg-box-even">
                                  <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 170"
                                  fill="none">
                                  <path
                                    d="M63.922 144.672L126 106.331V131.009L62.8678 170L0 131.171V106.494L61.8098 144.672C62.449 145.061 63.2829 145.061 63.922 144.672ZM0 0.162766V65.1426L62.8678 103.971L126 64.9798V0L0 0.162766ZM61.8098 111.657L0 73.4798V98.1569L62.8678 136.977L126 97.9851V73.308L63.922 111.648C63.2829 112.037 62.449 112.037 61.8098 111.648V111.657Z"
                                    fill="url(#paint0_linear_10100_101951)" />
                                    <text x="50%" y="50px" fill="#194965" class="percentage">{{item.text3}}</text>
                                    <defs>
                                      <linearGradient id="paint0_linear_10100_101951" x1="63" y1="85" x2="63" y2="170"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#78BE20" stop-opacity="0.2" />
                                        <stop offset="1" stop-color="#78BE20" stop-opacity="0" />
                                      </linearGradient>
                                    </defs>
                                  </svg> -->
                                  <div class="percentage percentage_Green">{{item.text3}}</div>
                                </div>
                                <div class="sol_Type" [innerHTML]="item.text4"></div>
                              </div>
                              <div class="vs_Vaccine">vs standard vaccines</div>
                            </div>
                            @if (item.text1) {
                              <div class="card-text" [innerHTML]="item.text1"></div>
                            }
                          </div>
                        </div>
                      }
                      <div class="large_Text" [innerHTML]="item.largeparagraphcontent"></div>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }